import React, { createContext, useContext, useState, useEffect } from 'react';
import { msalInstance, loginRequest } from 'authConfig.js';

const RoleTokenContext = createContext();

export const RoleTokenProvider = ({ children }) => {
  const [roleToken, setRoleToken] = useState(null);

  useEffect(() => {
    const getToken = async () => {
      try {
        const accounts = msalInstance.getAllAccounts();
        if (accounts.length === 0) {
          throw new Error('No accounts available');
        }

        const response = await msalInstance.acquireTokenSilent({
          scopes: loginRequest.scopes,
          account: accounts[0],
        });

        const definedUserRole = accounts[0]?.idTokenClaims?.extension_UserRole;
        setRoleToken(definedUserRole);
      } catch (error) {
        console.error('Error acquiring token:', error);
      }
    };

    getToken();
  }, []);

  return (
    <RoleTokenContext.Provider value={{ roleToken }}>
      {children}
    </RoleTokenContext.Provider>
  );
};

export const useRoleToken = () => {
  const context = useContext(RoleTokenContext);
  if (!context) {
    throw new Error('useRoleToken must be used within an RoleTokenProvider');
  }
  return context;
};
